export default "__VITE_ASSET__CY9X7YEa__"